import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataSummaryStore } from 'src/app/features/questionnaires/store/data-summary-store';
import { GeneryColumnComponent } from '../../genery-column/genery-column.component';
import { MiniContactDisplayComponent } from 'src/app/features/users/components/mini-contact-display/mini-contact-display.component';
import { DataToolbarComponent } from '../data-toolbar/data-toolbar.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { NoResultComponent } from 'src/app/shared/components/no-result/no-result.component';
import { map } from 'rxjs';
import { EQuestionType } from 'src/app/models/questionType.model';
import { QuestionData } from 'src/app/models/QuestionnaireDataByQuestions.model';
import { QueDatePipe } from 'src/app/pipes/date.pipe';
import { Router } from '@angular/router';
import { Recipient } from 'src/app/models/recipients.model';
import { SumbissionsMenuItemComponent } from '../sumbissions-menu-item/sumbissions-menu-item.component';

@Component({
    selector: 'que-sumbissions',
    imports: [CommonModule, GeneryColumnComponent, MiniContactDisplayComponent, DataToolbarComponent, TranslateDirective, TranslatePipe, NoResultComponent, QueDatePipe, SumbissionsMenuItemComponent],
    templateUrl: './sumbissions.component.html',
    styleUrls: ['./sumbissions.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class SumbissionsComponent {
  #storeData = inject(DataSummaryStore);
  #router = inject(Router);
  data$ = toSignal(this.#storeData.questionsData$.pipe(map(data =>
    [...data?.flatMap(q => {
      if (q.question.type.id == EQuestionType.QuestionsGroup && q.question.toNum == null) {
        return [...q.question.modularQuestions?.map(mq => {
          return {
            question: {...mq,id:0},
            questionSource:q.questionSource?.modularQuestions?.find(mqs=>mqs.guid==mq.templateModularGuid),
            comments: 0,
            recipients: [...q.recipients?.filter( r => r.answer.modularQuestionGuid==mq.guid)??[]],
          } as QuestionData;
        }) ?? []]
      }
      return [q];
    }) ?? []
    ])));
  recipients$ = toSignal(this.#storeData.filterRecipientsByReply$);
  loadingData$ = toSignal(this.#storeData.loadingData$);
  isDataForAllSig$ = this.#storeData.isDataForAllSig$;
  isLoadedCurretStep$ = toSignal(this.#storeData.isLoadedCurretStep$);
  questionsData$ = toSignal(this.#storeData.questionsData$);

  viewSubmission(recipient?: Recipient) {
    if (recipient?.guidToUser) {
      this.#router.navigate(['viewAnswers', recipient.guidToUser, 0]);
    }
  }

  //.pipe(filter(x=>x!=undefined),map(x=>{return [...x!,...x!,...x!,...x!,...x!]}));
  // questionsDic$ = toSignal(this.#storeData.questionsDic$);
  constructor() {
    this.#storeData.updateDisplayState("submissions");
  }
  // questionsDic2$ = this.#storeData.questionsDi$;

  // GenerateKey( recipient:Contact)
  // {
  //     return " " + recipient.lastName + "-" + recipient.firstName + "-" +
  //         recipient.date + "-" + recipient.isFull + "- recipient.mail";
  // }
}
